import { usePayrollData } from 'modules/finance/components/FinancialWorkspaceEmployeeCosts/hooks/usePayrollData'

import { Base } from './Base'
import { CustomChildrenProps } from './props'

export const Payroll = ({
  id,
  level,
  groupBy,
  headerLength,
  tableHeadRef,
  parentHasItemWithChildren,
  setParentHasItemWithChildren,
}: CustomChildrenProps) => {
  return (
    <Base
      id={id}
      level={level}
      type="payroll"
      groupBy={groupBy}
      hook={usePayrollData}
      headerLength={headerLength}
      tableHeadRef={tableHeadRef}
      parentHasItemWithChildren={parentHasItemWithChildren}
      setParentHasItemWithChildren={setParentHasItemWithChildren}
    />
  )
}
